module.exports = {
  message: {
    'hello': '妳好'
  },
  btn: {
    text: '按鈕'
  },
  common: {
  },
  header: {
    lang: '繁 / 簡體',
    home: '首頁',
    about: {
      index: '關於SFK',
      company: '公司簡介',
      brand: {
        index: '品牌介紹',
        symbol: '品牌標誌',
        idea: '品牌理念'
      },
      history: '發展歷程'
    },
    main: '主營項目',
    news: '新聞動態',
    join: '加入新福港',
    quality: '建築品質',
    contact: '聯系我們'
  },
  footer: {
    nav: {
      item1: '人力資源',
      item2: '法律聲明',
      item3: '聯系我們',
      item4: '駿延灣項目'
    },
    name: '新福港地產有限公司',
    subName: '廣州新福港地產置業有限公司',
    address: '地址 : 廣州市天河區林和東路285號中匯人壽中心7樓',
    phone: '公司電話 :（86-020）3839 1008',
    copy: 'Copyright © SFK Properties',
    licence: '粵ICP備12092793號-1',
    copyright: '版權所有：新福港房地產（深圳）有限公司'
  },
  home: {
    poster: {
      en: {
        title1: 'SFK',
        title2: 'PROPERTIES'
      },
      cn: {
        title: '細節品質，用心呈現',
        text: '新福港一直努力做好每一個細節，並不斷鑽研建築細節對生活品質的提升，創造性地運用設計、\n' +
          '技術和服務，為不同消費者提供理想的生活空間和高品質、高品位的豐盛生活。'
      }
    },
    about: {
      title: '關於我們',
      text: '　　新福港集團是香港著名的樓宇建築、土木工程及房地產開發公司， 成立於1948年，先後參與多項與香港及澳門發展息息相關的重要工程， 打造了香港汀九橋、東方文華酒店、中環太子大廈、朗豪坊、澳門威尼斯人酒店等多個影響力卓著的城市地標， 以建築品質享譽業界。<br/>\n' +
        '　　新福港地產為香港新福港集團的全資附屬公司，為集團的房地產及物業發展旗艦公司，秉承集團70餘年樓宇建設經驗及用心建造的優良傳統，采用國際性的設計視野，致力打造高素質物業項目；從2004年開始，先後在廣州、成都、珠海、佛山、蘇州、江門及順德等城市投資開發了十餘項房地產項目，業務遍及珠三角、長三角和西南地區，以提供舒適的居住環境和優越的生活品味為著眼點，以長遠回報為目標，專註進取為本，借助香港成功經驗為基石，精確地預見性，嚴謹細致的工作作風和孜孜不倦的努力，成功打造了一個又一個與國際潮流同步的優秀項目。'
    },
    main: {
      title: '主營業務',
      btn: '查看詳情',
      text1: '地產項目',
      text2: '酒店管理',
      text3: '商場運營',
      text4: '物業管理'
    },
    news: {
      title: '新聞動態'
    },
    quality: {
      title: '建築品質',
      ico1: '設計',
      ico2: '規劃',
      ico3: '施工',
      ico4: '質檢',
      ico5: '服務'
    }
  },
  about: {
    nav: [
      {
        title: '企業概述',
        item: '企業概述'
      },
      {
        title: '品牌介紹',
        item1: '品牌標誌',
        item2: '品牌理念'
      },
      {
        title: '發展歷程',
        item: '發展歷程'
      }
    ],
    info: {
      breadcrumb: '新福港地產有限公司',
      text: '　　新福港集團是香港著名的樓宇建築、土木工程及房地產開發公司， 成立於1948年，先後參與多項與香港及澳門發展息息相關的重要工程， 打造了香港汀九橋、東方文華酒店、中環太子大廈、朗豪坊、澳門威尼斯人酒店等多個影響力卓著的城市地標， 以建築品質享譽業界。<br/>\n' +
        '　　新福港地產為香港新福港集團的全資附屬公司，為集團的房地產及物業發展旗艦公司，秉承集團70餘年樓宇建設經驗及用心建造的優良傳統，采用國際性的設計視野，致力打造高素質物業項目；從2004年開始，先後在廣州、成都、珠海、佛山、蘇州、江門及順德等城市投資開發了十餘項房地產項目，業務遍及珠三角、長三角和西南地區，以提供舒適的居住環境和優越的生活品味為著眼點，以長遠回報為目標，專註進取為本，借助香港成功經驗為基石，精確地預見性，嚴謹細致的工作作風和孜孜不倦的努力，成功打造了一個又一個與國際潮流同步的優秀項目。'
    },
    brand: {
      breadcrumb: '品牌介紹 ',
      title1: '品牌標誌',
      text1: '新福港地產品牌標誌由香港著名設計師靳埭強教授設計，此商標重點突出中國獨特的瓦片建築技術，綠瓦櫛比鱗次，結構巧妙，加上遊魚象征新福港傳承中國傳統的優良建築概念，為現代人提供安逸清幽的居所。',
      title2: '品牌理念',
      text2: '“細節品質，用心呈現。”是新福港品牌的核心理念，也是新福港地產堅持的核心價值觀 。70餘年來，新福港一直努力做好每一個細節，並不斷鑽研建築細節對生活品質的提升，  創造性地運用設計、技術和服務，為不同消費者提供理想的生活空間和高品質、高品位的豐盛生活。'
    },
    history: {
      breadcrumb: '發展歷程 '
    }
  },
  main: {
    nav: [
      {
        title: '地產項目',
        list: [
          {
            title: '發展項目',
            item6: '黃埔【新福港·鼎峰】',
            item1: '佛山【新福港·鼎峰】',
            item2: '廣州【新福港·鼎薈】',
            item3: '廣州【新福港·鼎峰】',
            item4: '成都【御青城度假別墅】',
            item5: '江門【峻廷灣】'
          },
          {
            title: '合作項目',
            item10: '深圳寶安 · 碧海玖號',
            item1: '珠海映暉灣',
            item2: '廣州力迅 · T',
            item3: '廣州力迅 · 原築',
            item4: '蘇州楓華紫園',
            item5: '蘇州未名園',
            item6: '成都領築國際公寓',
            item7: '成都福字街',
            item8: '廣州珠江怡景灣',
            item9: '佛山新紅棉大廈'
          }
        ]
      },
      {
        title: '酒店管理',
        list: [
          {
            title: '',
            item1: '酒店管理'
          }
        ]
      },
      {
        title: '商場運營',
        list: [
          {
            title: '',
            item1: '商場運營'
          }
        ]
      },
      {
        title: '物業管理',
        list: [
          {
            title: '',
            item1: '物業管理'
          }
        ]
      }
    ],
    des: [
      {
        title: '地產項目',
        list: [
          {
            title: '佛山 -【新福港·鼎峰】',
            text: '項目位於禪城區發展中軸線魁奇路與汾江南路交匯處，佔地約8萬平方米，承建一座55萬平方米的城市綜合體。<br/>\n' +
              '作為佛山首個、也是目前唯一一個雙地鐵上蓋的城市綜合體，<b>項目有著無可媲美的交通通達性</b>：<br/>\n' +
              '廣佛線及佛山：<br/>\n' +
              '2號線交匯 ，位處連接廣佛東西與南北城際通道的核心，3站到祖廟，9站到廣州南站，暢通廣佛兩地；周邊路網發達，30分鐘接駁廣州、5分鐘可達佛山各區，2小時可到香港。<br/>\n' +
              '<br/>\n' +
              '屹立於佛山本土，城南核心富人區，周邊配套更是齊備； <b>10分鐘生活圈內有3大商圈圍繞、3大省級名校環繞、2大三甲醫院、5個城市公園、2個體育場館；</b><br/>\n' +
              '作為佛山市中心前所未有的大型優質城市綜合體，我們除了外在本已顯赫的配套優勢，更有內在八面玲瓏的美態，新福港·鼎峰，傾力築造城央精英生活居所：<br/>\n' +
              '<br/>\n' +
              '<b>設計上：</b>\n' +
              '10萬平方米的5層商業裙樓和3萬方的空中水景園林組成，整個項目將城市居住生活-空中水景園林-繽紛購物天地-地面路網交通-地下地鐵快節奏五重生活場景有效串聯起來，打破了常規綜合體建築形態的限製，精心打造一種更高級的生活形態。<br/>\n' +
              '<br/>\n' +
              '<b>產品上：</b><br/>\n' +
              '住宅/酒店式公寓、酒店、商場物業形態，由9棟塔樓，包括A1-A6、A9棟共7棟住宅及A7-A8棟2棟酒店式公寓所組成，其中於A7棟23-36層更引進了全球酒店領先品牌---洲際酒店集團旗下的服務型酒店，智選假日酒店進行公寓統一式管理，重新定義佛山優質城市生活。<br/>\n' +
              '<br/>\n' +
              '<b>智選假日酒店進駐：</b><br/>\n' +
              '誕生於1991年的智選假日酒店隸屬於全球三大品牌之一，洲際酒店集團旗下的服務型酒店。作為業內發展速度領先的酒店品牌之一，智選假日酒店以物超所值的價格為世界各地的商務旅客和休閑遊客，提供高效、簡潔、貼心的入住選擇。截至2018年第一季度，智選假日酒店在全球擁有2,618家開業酒店，大中華區共有103家開業酒店，分佈在全國40多個城市。<br/>\n' +
              '新一代的智選假日酒店定位於佛山禪城繁華區域，填補了這一市場高端酒店定位的空隙；得天獨厚的項目優勢加上國際星級酒店進駐，代言本地最高標準港式精英生活。未來，這裏名流薈萃，出入皆精英名仕，全面提升項目品質，入住率、租金及物業價值也會隨之提高，不管是投資、自住、商旅、辦公，皆能滿足。<br/>\n' +
              '<br/>\n' +
              '<b>三大商圈：</b><br/>\n' +
              '三大商圈圍繞，北有禪城區核心商務帶——季華路商圈，創意產業園、順聯國際、印象城等大型商業配套；南有佛山最成熟住區——城南商圈，有兆陽廣場、惠景書城、麗日商業街等生活型配套；西面有全國規模最大的陶瓷建材商貿圈，佛山陶瓷年總產值超1000億元。<br/>\n' +
              '<br/>\n' +
              '<b>多所教育名校:</b><br/>\n' +
              '項目周邊遍佈多所重點學校，10分鐘車程均可到達。<br/>\n' +
              '小學：綠景小學（省一級）、城南小學（省一級）、惠景小學（市一級）；<br/>\n' +
              '初中：華英學校（重點省一級）、惠景中學（市一級）、瀾石中學（省一級）；<br/>\n' +
              '高中：市三中（國家級示範）、市二中（國家級示範）；<br/>\n' +
              '<br/>\n' +
              '<b>兩大三甲級醫院:</b><br/>\n' +
              '佛山市第一人民醫院（三甲）、禪城中心醫院（三甲）<br/>\n' +
              '<br/>\n' +
              '<b>五大公園:</b><br/>\n' +
              '文華公園、亞藝湖公園、季華園、濱江濕地公園、石灣濕地公園'
          },
          {
            title: '廣州 -【新福港·鼎薈】',
            text: '在廣州城市中心自由穿梭，沿途欣賞著飛機劃過天空留下的白色痕跡；約20分鐘的行程，從機場到項目，享盡繁華與空間的切換，此情此景，非遙不可及；城央、空港、地鐵、高速與人居高度結合的代表作，約24萬㎡城市商業綜合體正榮耀登場。<br/>\n' +
              '<b>項目位於白雲區江府路與廣花三路交界，</b>毗鄰江高鎮政府，為江高鎮首個正式房地產開發項目，致力打造成為江高地標性建築。項目佔地約98718㎡，總建面約24萬㎡，項目涵蓋創意LOFT、精品酒店、時尚商業於一體；集創意辦公、商務接待、時尚生活、購物休閑、餐飲美食、精彩薈於一城；將打造為白雲區繁華新門戶，江高中心新地標。<br/>\n' +
              '<br/>\n' +
              '項目所在為江高鎮政府旁，為江高發展的重點位置，<b>距離地鐵8號線北延段江府站僅200m，屬地鐵上蓋物業，交通便捷，江府站更是8號線與24號線的更換站。</b>2023年該8號線北段通車後，將與原有的快速路、機場高速等連為一體。立體式交通的網絡，必將給客戶的生活與產品的升值帶來新的高度。<br/>\n' +
              '<br/>\n' +
              '以卓越品質，獻予卓越人群，項目設計匠心獨運、精雕細琢；共分四期開發，現正處第一期階段，首批為復式精裝LOFT雙層公寓，擁有超高使用率；產品面積段豐富，涵蓋35m²-80m²面積段，戶型從兩房到四房，充分滿足不同層次的人居需求。<br/>\n' +
              '與城市心臟共同躍動，與人居脈搏相結合；廣州江高地標綜合項目，以全新視角締造城市繁華，開啟江高商業人居新時代。'
          },
          {
            title: '廣州 -【新福港·鼎峰】',
            text: '該項目是新福港地產進駐廣州的首個大作，<b>位於廣州黃埔區府旁，科學城核心位置，南鄰國際配套廣州國際演藝中心（NBA籃球館），北倚善坑頂自然山脈，  佔據城市高點，景觀視野開闊。</b><br/>\n' +
              '項目遠離市區繁囂卻又不失交通便利，<b>緊接6號線蘿崗站、公交站點為蘿崗中心樞紐總站，家門口的地鐵盤和公交首發站，在家門口即可享雙線服務，20分鐘直達珠江新城。</b>該項目佔地面積為12.5萬平方米，總建築面積約29萬平方米，規劃開發31棟13-31層高層觀景洋房，共1600餘戶，分四期開發。<br/>\n' +
              '<br/>\n' +
              '項目產品類型豐富，涵蓋了面積從80-250㎡全系列兩至四房，其中主力戶型為120-200㎡南北對流舒適三房至寬闊山景四房，打造成廣州黃埔區府旁首屈一指的港式半山豪宅。<br/>\n' +
              '<br/>\n' +
              '作為頂尖的高級住宅社區，為築造獨一無二的尊貴生活居住典範，住戶可私享兩座半山之上，水岸之邊的國際藝術會所，廣州首個私家畫廊，融合了大面積植被水體的高落差臺地立體親水園林和身後的私家山體公園，以及多維的公共藝術空間；同時小區內還設有約三萬平方米的配套商業，配備有幼兒園、文化活動站、老人活動中心、肉菜市場、衛生站等設施，為住戶提供全方位優質的生活服務。'
          },
          {
            title: '成都 -【御青城度假別墅】',
            text: '坐落於擁有”天下第一幽”美譽的都江堰·青城山風景區，  青城山年平均氣溫15度左右、森林覆蓋率達95%以上。  四季林木茂盛、終年青翠，<b>距離成都市區、雙流機場約60公裏，青城山快鐵站約9公裏。</b>景區負氧離子數量達到了22000—31000個/立方厘米，是成都市區的180倍，成為中國大型的天然養生度假聖地。青城山也是著名的道教名山，世界文化遺產、中國文化聖地、國家5A級風景區，其不可復製的自然資源和深沈的人文底蘊相得益彰、舉世無雙。<br/>\n' +
              '<br/>\n' +
              '御青城泰式風情度假別墅，藏於青城，心之歸墅。佔地約200畝，以東南亞建築風格為藍本設計，並結合青城山獨有的地方文化氛圍，融入泰式園林藝術，千姿百態的自然水系有序交融，匯成生氣盎然的有機脈絡，將建築與自然渾然一體。80-300㎡合院、聯排、雙拼、獨棟，錯落有致的點綴在青山秀水中，大露臺、私家庭院盡顯異域泰國風情。<br/>\n' +
              '<br/>\n' +
              '本項目區別於傳統別墅，  它配有度假別墅酒店。  匯集度假、養生、商務於一體，泰式餐廳、泰式SPA和養生館、室內/室外恒溫泳池、水療按摩池，健身房、瑜伽室、品茗軒、兒童遊樂園、會議室等一應俱全。港式酒店管理，住戶享受更加全方位的度假生活。'
          },
          {
            title: '江門 -【峻廷灣】',
            text: '峻廷灣與城市商業中心區僅需步行5分鐘，被沙坪河環繞，項目佔地25萬平方米，總建築面積達57萬平方米，首期為純別墅社區，二、三期規劃建設有洋房、商業街、小學及幼兒園。<br/>\n' +
              '<br/>\n' +
              '峻廷灣在項目設計上非常註重建築與人、建築與城市、建築與自然的友好共生，既充分考慮古勞水鄉的生態特點，也關注鶴山城市發展的形象需要以及居民生活品質提升的居家需求，充分考慮每一棟建築、每一種戶型的設計均好性，讓建築以謙和的姿態棲居在自然之中。<br/>\n' +
              '<br/>\n' +
              '新福港將峻廷灣項目作為鶴山別墅物業的標桿來打造，在功能配套規劃、社區建設、生態景觀等方面，以國際級品質為基本要求，致力為鶴山帶來前所未有的品質生活，成為鶴山城市發展的里程式標桿。'
          },
          {
            title: '珠海映暉灣',
            text: '項目位置：珠海 <br/>\n' +
              '珠海市前山河旁住宅項目 ─ 映暉灣的構思初衷，就是基於為大家建設一個離城不離市的優美居庭。規劃良好的珠海市是廣東省內其中一個十分適合安居樂業的城市，而新福港在此發展的映暉灣坐落於當地四通八達的地帶，朝南而景觀開闊。映暉灣的業主們更可坐享附近小區的成熟配套，鄰近還有香洲一小分校、商業街、市場、交通等設施，完善的設施解決了業主們的日常生活所需，讓大家安心居住。',
            city: '珠海'
          },
          {
            title: '廣州力迅·T',
            text: '項目位置：天河區黃埔大道，翠湖街交匯處<br/>\n' +
              '佔地面積：6495.80平方米　/　總建面積：45286平方米。<br/>' +
              '主推精致小戶型，佈局合理、采光充足、設計簡約、功能齊全，整體舒適度極高，屬於珠江新城一帶性價比高的物業。<br/>\n' +
              '周邊配套成熟，擁有國際化生活社區，處於天河公園板塊，靠近華南快速幹線、黃埔大道中，出行十分方便，5分鐘可到達各大型商業購物中心。',
            city: '廣州'
          },
          {
            title: '廣州力迅·原築',
            text: '項目位置：花地大道西，坑口地鐵站和西朗地鐵站之間。<br/>\n' +
              '園林面積：約1.5萬平方米　/　總建面積：約9.4萬平方米<br/>\n' +
              '簡約中帶古典建築風格，予人以優雅。多樣的戶型，配以不同風格的設計，成為獨具慧眼的單身貴族及小康之家的理想家園<br/>\n' +
              '地理位置優越，交通脈絡匯集，位處芳村的新商圈中心地帶，不僅周邊配套完善，且小區內自設三層獨立會說、大型泳池等均讓住客四季皆體驗生活的壯美。',
            city: '廣州'
          },
          {
            title: '蘇州楓華紫園',
            text: '項目位置：蘇州市吳中區金楓路東側<br/>\n' +
              '佔地面積：約8.4萬平方米　/　總建面積：約30.6萬平方米　/　綠地率：約53%<br/>\n' +
              '整個小區采用了簡約的建築風格，在建築立面的造型、色彩及戶型的設計上體現了浙建地產一貫地追求合理、舒適的理念，' +
              '並融入了蘇州的文化脈絡，使整個建築平和、自然的融入到社區的整體環境中。',
            city: '蘇州'
          },
          {
            title: '蘇州未名園',
            text: '項目位置：位於蘇州市吳中區浦莊鎮浦莊大道<br/>\n' +
              '佔地面積：約7萬平方米　/　總建面積：約4.6萬平方米<br/>\n' +
              '未滿足未名園業主對生活品味的追求，建築師以充滿優雅東方韻味的裝飾，襯托簡約時尚的西方建築，使每一所房子都是文化的結晶' +
              '<br/>\n' +
              '位於優越的太湖板塊，擁有彌足珍貴的山水人文資源，更被著名旅遊景點環抱，包括農林大世界、東山風景區、蘇州太湖國家旅遊度假區等，大自然' +
              '就在離家門口不遠之處。',
            city: '蘇州'
          },
          {
            title: '成都領築國際公寓',
            text: '項目位置：位於成都市中心的文翁路與金盾路交匯處<br/>\n' +
              '毗鄰天府廣場、人民公園。寬窄巷子、武侯祠、錦裏、耍都及琴臺路均處於樓盤周邊。<br/>\n' +
              '距春熙路1公裏、距機場16公裏、火車站5公裏，步行可至地鐵一、二號線天府廣場站、人民公園、天府廣場等繁華地段，周邊景點雲集,交通便捷、購物方便、鬧中帶靜，配套成熟，休閑、娛樂、商務、生活於一身，獨擅城央地利之優',
            city: '成都'
          },
          {
            title: '成都福字街',
            text: '　　家在市區的繁華地段，日常的便利已經是唾手可取，時尚之物觸目皆是，多姿多彩的生活更時刻顯得璀璨；蔔居於成都黃金核心區新建構的福字街項目，固然擁有以上一切，還可兼得舊城特色和時代氣息迸發的生活新火花。<br/>\n' +
              '　　福字街項目位於成都市中心錦江區福字街與書院南街交匯處，緊鄰錦江區政府和商業核心區居室內最繁華的商業步行街「春熙路」僅百米之遙，地理位置優越。這座高級商住樓位於區內興旺的地段，卻多了一分寧靜的氛圍，提供理想的高品位生活，提現不一樣的居住、生活和消費樂趣。家門內，妳可以投入高雅時尚的生活享受；家門外，妳可找到街坊式的親切感和傳統市鎮的情懷，經常獲得嶄新的體會和發現。<br/>\n' +
              '　　春熙路是成都最具代表性、最繁華熱鬧、歷史極為悠久的步行街，此處的商貿業極為發達；兒由總府路以南、上東大街以北、紅星路以西和鹽市口以東組成的春熙路商圈，是成都老城區三大商圈之一。座落於春熙路附近的福字街項目，是政府的一級重建項目，旨在將它打造成地標式都市景觀區域，並使之成為市中心商業區的延伸。<br/>\n' +
              '　　隨著福字街項目的開發，換上新面貌的成都將更閃更亮，而居於此處的生活格調將會加倍時尚精彩。\n'
          },
          {
            title: '廣州番禺珠江怡景灣',
            text: '項目位置：番禺大石鎮華南快線番禺大橋側，<br/>\n' +
              '佔地約120,000平方米，建築面積達210,000平方米，周邊還有其他著名住宅及別墅項目，區內並有超市、幼兒園等，生活配套完善，屬番禺區內開發較早的成熟小區之一。理想的居所，除了講究優美的地理環境和完善的配套設施外，還要求有卓越的發展潛力。在番禺房地產發展項目的選址上，除了周邊小區發展成熟的配套外，我們更看重政府在該區的發展藍圖。'
          },
          {
            title: '佛山新紅棉大廈',
            text1: '走在順德區，馬上感覺到熱鬧興旺的氛圍。於順德區的服務式公寓，毗鄰\n' +
              '新世界中心商場及市內唯一國際4星級的新世界萬怡酒店；薈萃閒情逸致的華蓋\n' +
              '路商業購物街和多個大型商場；以及廣東四大名園之一、以嶺南庭院古樸風格而\n' +
              '著稱的清暉園。座落於這個黃金地段的順德區服務式公寓，處處盈滿精彩生活元\n' +
              '素，簇擁天賦的繁華優勢。<br/>\n' +
              '置身高雅舒適的生活空間，身心自必閒逸舒泰。新紅棉大廈由新加坡規模\n' +
              '最大的著名建築設計公司之一 —— DP  Architects負責整體規劃及建設，約\n' +
              '28,000平方米的總建築面積之內，一隅一角均凝聚建築師及設計師的巧妙創意\n' +
              '和心思。',
            text2: '以小戶型為主的單位設計，室內時尚雅致，崇尚簡約高潔，呼應單身貴族或新婚兩口子的現代生活態度。當然，他們的寫意體驗亦備受重視,居住區內除了提供酒店式服務之外，也設有泳池和健身室等配套，加上一至四層為購物中心，既帶來消閒樂趣，也滿足日常需要。此項目不僅擁有享受之利，更位處城市樞紐核心，別具交通之便。從這裡前往順德港碼頭僅20分鐘車程，往廣州白雲機場只需1.5小時車程。而即將全面開通的珠江三角洲西岸幹道，將成為一條直接連繫廣州、順德、中山及珠海之高速公路系統，穿梭於國內各地自是隨心所欲。順德服務式公寓綻放獨特的風度情緻，勾勒出時尚都市的新面貌，必能讓您幸福湧動。'
          },
          {
            title: '黃埔 -【新福港·鼎峰】',
            text: `
                    　　黃埔新福港鼎峰是新福港在廣州黃埔區繼蘿崗新福港鼎峯後的又一力作，
                    它將再次定義新福港打造標杆社區的<b>人居新高度，黃埔新標杆</b>。<br/>\n
                    　　項目位於廣州開發區核心區域，毗鄰省一級小學廣州開發區二小，
                    距離地鐵5號線東延線黃埔新港站僅約5分鐘，交通便利。未來實施西區振興計劃，
                    打造世界製造業總部經濟區、海絲國家免稅貿易區，項目將成爲廣州開發區西區轉型升級的典範之作。<br/>\n
                    　　<b>匠心規劃，功能齊全</b>，在社區生活功能規劃上，項目獨具匠心，
                    將3F、14F架空層打造成全維生活動區，不僅設有無邊際泳池、乒乓球區、少年籃球區等運動設施，
                    還規劃有藝術繪畫區、閱讀區、兒童樂園等休閒場所，滿足家庭全齡生活需求。<br/>\n
                    　　項目臨近東江北支流，坐擁景觀資源，88-130方三至四房舒適型產品，
                    大陽臺，大飄窗，全屋窗比超50%，明亮寬敞，打造高舒適性居住新產品。<b>高層全江一覽，打造不一樣的鼎峰</b>。`
          },
          {
            title: '深圳寶安 -【碧海玖號】',
            text: `
                    　　項目位於前海合作區，充分發揮核心引擎作用，享有海陸空鐵軌五維交通體系，<br/>\n
                    快速連接全球；項目距離11號線碧海灣站500米，15分鐘直達機場/寶中，20分鐘至前海，25分鐘到南山中心。<br/>\n
                    　　通過與南山、福田的協同發展，提升寶安中心區及周邊南部地區的整體能級。<br/>\n
                    　　項目位於“<b>寶安中心區及大鏟灣片區</b>”，處於前海“一心一帶雙港五區”中的核心——前海城市新中心。<br/>\n
                    　　提升全球資源配置能力，推動總部、貿易、服務和會展經濟發展，打造灣區“<b>國際會客廳</b>”，潛力巨大。<br/>\n
                    　　項目位於⻄鄉街道銅⿎堡路與寶瑰路交界東側，距離11號線碧海站500m，佔地：4.16萬㎡， 總建面：14.21萬㎡， 容積率：2.2。
                    其中，住宅7.9萬㎡，商業4900㎡，公寓4900㎡，幼兒園2200㎡，地塊限高90m，推售戶型：106-186㎡4-5房。
                    `
          }
        ]
      },
      {
        title: '酒店管理',
        list: [
          {
            title: '御青城度假別墅酒店',
            text: '青城山——全球道教主流教派全真道聖地，世界5A級雙遺產，中國四大道教名山之一。<br/>\n' +
              '<br/>\n' +
              '御青城度假別墅酒店坐落於擁有“天下第一幽”美譽的青城山。由香港新福港集團投資按星級標準興建，打造都江堰首席泰式文化主題酒店。是一家集商務、會議、度假、康養功能為一體的度假別墅酒店。<br/>\n' +
              '<br/>\n' +
              '酒店裝飾宏偉大方，內部裝飾流金溢彩，相得益彰，是融合泰國風情與青城文化的完美結晶。酒店設施齊全，服務項目眾多，餐飲設施有泰國創作料理餐廳、大堂吧、露天燒烤吧。酒店還有配有多功能會議室、室內恒溫泳池、室外泳池、健身房、臺球室、水療按摩池、兒童遊樂、品茗軒等設施。酒店采用星級港式酒店管家服務，提供定製旅遊、商務、生活、度假等服務，致力為賓客提供奢華舒適的泰式生活度假享受。'
          }
        ]
      },
      {
        title: '商城運營',
        list: [
          {
            title: '“新·DNA”購物中心',
            text: '新福港地產在佛山首個匠心之作 “新•DNA” 大型城市綜合體項目，位於佛山市禪城區魁奇路與汾江南路交匯處，廣佛地鐵1號、2號線換乘點，雙地鐵上蓋，魁奇路地鐵站C出口與購物中心無縫銜接。<br/>\n' +
              '新.DNA購物中心總面積10萬平方米，將成為佛山一個新地標。匯集國際快時尚品牌，其中更有多個品牌首次進駐佛山。主力品牌AEON超市。MELAND兒童樂園、ADIDAS、周生生、六福珠寶、麥當勞、香港翠華餐廳、星美國際影城等，為佛山帶來新的歷奇體驗式購物時尚天地。'
          },
          {
            title: '新·DNA 理念',
            text: '1 新地標<br/>\n' +
              ' （1）超高層城市地標建築<br/>\n' +
              ' （2）雙地鐵無縫對接，2700個車位<br/>\n' +
              ' （3）集購物中心、住宅、公寓、酒店、樞紐中心<br/>\n' +
              '2 新體驗<br/>\n' +
              ' （1）全業態 、全齡層，精心打造歡樂消費之旅<br/>\n' +
              ' （2）巨資打造歷奇天地，驚喜無限<br/>\n' +
              ' （3）匯聚世界美食，打造舌尖上的佛山<br/>\n' +
              '3 新匯聚<br/>\n' +
              ' （1）佛山單層面積最大的永旺超市<br/>\n' +
              ' （2）3D巨幕影院及特設兒童廳引爆潮流<br/>\n' +
              ' （3）強強聯袂，勢在登頂'
          },
          {
            title: '新·DNA 主題',
            text: '繽紛郵輪 ——  隨時開啟多彩“旅途”<br/>\n' +
              '科幻歷奇  —— 突如其來的“驚喜”<br/>\n' +
              '燈塔冒險  —— 一起放聲“歡笑”'
          },
          {
            title: '新·DNA 購物中心',
            text: '佛山得天獨厚的優越地理位置，<br/>\n' +
              '新·DNA擁祖廟商圈、<br/>\n' +
              '佛山新城商圈、季華商圈、桂城商圈，<br/>\n' +
              '四大主力成熟商圈，完美輻射100萬人口。<br/>\n' +
              '廣佛地鐵進一步深化廣佛同城，<br/>\n' +
              '未來人流量，不可限量。'
          }
        ]
      },
      {
        title: '物業管理',
        list: [
          {
            title: '物業管理',
            text: '　　佛山新福港物業管理有限公司（原名：佛山寶得物業管理有限公司）成立於2010年9月，是一家具有國家三級資質的外商獨資企業，隸屬於香港新福港集團，在香港證券交易所上市。\n' +
              '因業務發展需要，公司分別在2011年和2016年依法註冊成立了江門分公司和廣州分公司，並於2017年依法註冊成立了廣州子公司。\n' +
              '為規範公司的發展，公司先後加入佛山房地產協會和江門物業管理協會，並取得ISO9001:2008的國際質量標準認證。\n' +
              '為打造優質物業服務品牌，汲取國際物業管理經驗，公司曾與香港鷹君集團和世界五大行“高力國際”合作，力求用專業、規範、酒店式的標準，用心為客戶提供每一項服務。\n' +
              '迄今為止，公司為客戶提供的服務包括早期介入顧問服務、銷售案場服務、前期物業服務以及前期物業服務顧問服務。公司服務項目位於廣州、佛山、江門、成都等地，服務類型有別墅、高層住宅、會所、商業、城市綜合體等。'
          }
        ]
      }
    ]
  },
  news: {
    nav: [
      {
        title: '新聞動態',
        item: '新聞動態'
      }
    ],
    list: [
      {
        breadcrumb: '新聞動態 ',
        text: ''
      }
    ]
  },
  join: {
    nav: {
      title: '加入新福港',
      item1: '企業文化',
      item2: '人才理念',
      item3: '崗位招聘',
      item4: '招聘聲明',
      item5: '法律聲明'
    },
    culture: {
      title: '企業文化 ',
      list: [
        {
          text: '<p class="title">始於1948年的細節品質   源自幾代人的處處用心</p>'
        },
        {
          text: '<p class="text">新福港集團是香港著名的樓宇建築、土木工程及房地產開發公司，成立於1948年，參與了多項與香港及澳門發展息息相關的重要工程，以細節品質享譽業界。\n' +
            '作為一家擁有多年建築經驗和多個港澳城市地標建設經驗的知名企業，新福港集團始終秉承‘給社會最好的建築’的企業信仰，堅持做好每一處細節成為其永不放棄的夢想與追求。時至今日，文華東方酒店、中環太子大廈的堅固如初，汀九大橋的精確施工，朗豪坊的建築選材，迪士尼好萊塢酒店的七星級酒店標準施工建造，威尼斯人會議展覽中心的高規格驗收標準~~無不成為建築業界的經典傳奇。\n' +
            '新福港地產是新福港集團的全資附屬公司，為集團的房地產及物業發展旗艦公司，現時的房地產項目遍及珠三角、長三角及西南地區。新福港地產擁有國際性的設計視野，傳承60餘年精工品質建造經驗，封頂目的用料和結構建造尤其重視，致力打造一個又一個內外兼備的高素質物業項目，成就高品質、高品位的新經典、新傳奇。</p>'
        },
        {
          text: '<p class="text">新福港是一家優秀、傳統的企業,秉承著創始人羅啓瑞先生待人接物的理念:用盡心思做足功課,服務客戶至極致。\n' +
            '多年的建築經驗告訴我們,產品細節才是建築的價值所在。新福港善於捕捉和鑽研一些很細微但卻能令生活提升的元素,我們嘗試按每—位潛在客戶的個性需求來訂造產品,我們傾盡所能為所有欣賞生活藝術的用戶,提供舒適又優質的生活環境,匹配他們對生活品味的追求,啟迪人生,令生活更趨美滿。</p>'
        },
        {
          text: '<p class="text">新福港創辦至今,業務發展理念和企業文化都是以人為本，以生活中心，以社會價值最大化為己任。我們位於亞洲的多項建築工程，以及在中國內地的房地產項目,均是從人性根源需求岀發,以塑造更趨美滿的生活為企業社會責任。\n' +
            '新港在社區規劃、產品設計、用料選擇、建造施工、質量管理、物業服務等房地產開發的各個領域，均擁有經驗豐富的專業團隊，其中不少員工在公司服務10年以上。每一個新福港員工,都恪盡本份,怊守專業精神和企業道德。如果我們每天所的工作，就算只是為這世界帶來一點點的貢獻，那都讓我們倍感快慰。</p>'
        },
        {
          text: '<p class="text">新福港在各主要房地產及物業開發項目的選址上均經過細意考量，務求達到生活既被蒼翠的大自然環抱，又具備二十一世紀都市的先進設備及咫尺之隔的便利。\n' +
            '在進行項目分析的時候，我們會詳細了解和評估項目所處的位置、自然環境、人文景觀、消費需求，以及城市發展對項目的需求,註重人文素養在建築中的體現。我們嘗試站在客戶的角度來規劃項目,考慮到他們對環境、對空間、對生活、對肚交等各個方面的期望，創造更為理想、和諧的美滿生活。我們會打造一個獨一無二，並目契合那裏的建築。</p>'
        },
        {
          text: '<p class="title">品質決定價值!\n<br/>' +
            '妳看得見的好房子</p>' +
            '<p class="text">新福港·鼎峰的質量管理團隊，是香港眀豪坊與迪士尼工程的質量管理團隊的原班人馬，他們管理的流程與標準，都比內地現有的標準要嚴格，為了保證質量把關的公正嚴謹,他們的所有工作都需要直接向香港集團總部進行匯報。無論從住戶看到還是看不到的層面，他們都十分關注細節，精雕細琢。\n' +
            '行業人士都知道，一個樓盤項目，最為棘手顯眼的問題就是漏水。為了杜絕這個問題，鼎峰在選擇窗框材料時全部都使用壓力槍進行測試；在廁所環境建設中會做24小時浸水測試,以避免收樓後的房屋滲漏。\n' +
            '而在住戶看不見的方面，新福港·鼎峰也執著追求精益求精。例如,鼎峰樓板厚於一般的建築樓板,以更好地避免上層走動、活動聲音影響到下層用戶的生活;鼎峰采用了25米/秒的電梯，這是高於蘿崗大多數樓盤采用的1.8-2米/秒的上升速度，為住戶節約不少時間；一般樓盤的30層建築均采用管椿,而即便是17層的小高層樓體,鼎峰也采用成本更高、但更安全的衝孔灌註樁；國家標凖的打樁λ巖深庋是30cm；而鼎峰的標凖是入巖深度達到100m。</p>' +
            '<p class="title title2">為了建築多照1小時太陽,\n<br/>' +
            '我們將設計改動57次</p>' +
            '<p class="text">廣東佛山新福港廣場項目，是新福港地產在大陸開發的第一個地鐵上蓋城市綜合體。新福港考察了國內外多個知名商業項目，並委托第\n' +
            '太平戴維斯進行深入的市場調查，還聘請了三家擅長商業規劃的顧問公司：第一太平戴維斯、恒昌、華夏柏欣，參與該項目的商業定位工作。\n' +
            '通過對三家公司的方案進行反復的比較論證，綜合各家所長，最終才確定佛山新福港廣場項目的商業定位方案。而在佛山新福港廣場項目的開發過程中，新福港與陽光玩了一個小遊戲。作爲包括商業和住宅的城市綜合體項目，新福港對日照有著區別於普通住宅建築的要求，同時，中國人沿襲了幾千年的居住習慣，也對陽光有著異乎尋常的偏好和喜愛。\n' +
            '新福港廣場項目建築設計的初稿，在“日照”這一指標上與公司製定的標準相比少了一點。這也許衹是一件小事,但在新福港眼中卻是\n' +
            '件大事。為了讓建築享受到更多的陽光，新福港設計部門的員工經過數十個晝夜,上百次討論,57輪修改……終於，新的設計稿通過了。</p>'
        },
        {
          text: '<p class="text">建材對於建築猶如一個人的骨骼和血肉，優質的建材才能使建築健康長久地使用。新福港對於選材，有一整套完整而嚴謹的體系。通常我們會根據一套嚴格的步驟去評核不同物料的供貨商。並實地考察他們的工廠，對他們的規模、技術和信譽有信心，才向他們采購。對於鋼材和混凝土等主要建材,，我們會比一般條例要求或者行內習慣提出更高的質量要求,做更多和更頻密的樣板測試。從我們的專業經驗來說，符合標準不一定等於安全可靠，從工程開始到結朿,我們會在施工中進行反復測試,對項目的結構有所掌握,工序因而更繁復,成本也更高，但這正是新福港的專業性和企業道德所在。</p>'
        },
        {
          text: '<p class="title">嚴格的選材標準，讓建築品質贏在起點</p>' +
            '<p class="text">朗豪坊的設計概念是“石頭之城”，所用石材全部來自巴西一個從未經采用的石礦，為的是確保在朗豪坊之前沒有別的建築用過這個紋理的石頭。從石礦送來的石材，新福港要確保它們都是高質素的，亦要做測試，確保石材的硬度足夠，受壓能力亦能達到朗豪坊的建設標凖。此外，石材的大小和顔色等都有嚴格的要求，設有顔色標凖來做比對。\n' +
            '朗豪坊有一個很大的鋼結構部分，其中包括支撐一個樓底跨度逹ω米的中庭，新福港選用了來自日本的鋼材，雖然價錢較貴，但由於那些日本鋼材製造的時候誤差十分低，這就能確保鋼結構的穩固。</p>' +
            '<p class="title title2">一個跨越萬裏、價值20萬美元的測試</p>' +
            '<p class="text">新福港在施工過程中，會把項目可能面對的種種極端情況都考慮到，進而在建設過程中采用相應的解決辦法。新福港集團承建的澳門威尼斯人會議展覽中心項目，總樓面面積達13萬平方米。在建造過程中，除了反復做不同的檢驗程序外，在澳門威尼斯人會議展覽中心的上蓋正式裝上前，我們將部分材料送往美國做測試，確保它的防水、防風、受力及結構堅固程度等。這測試花了20萬美元,爲的是要達到國際級的標準。</p>'
        },
        {
          text: '<p class="text">新福港認為，再宏偉的設計構想，如果不賦予—個嚴謹到苛刻的建造過程，再好的設計也沒有成為現實的可能。新福港在香港就以工程質量莕稱，在建造全過程，都以苛刻的標準要求自己，只為城市、為城市中的人建造岀優質的產品。\n' +
            '在建築過程中，我們與設計師緊密聯系,每—個細節做了很詳細的施工圖，確保每個部都是準確無誤。每道工序都有嚴謹的規劃，確保項囯施工有條不紊進行。\n' +
            '如果需要趕工，我們也絕不會犧牲質量，而是思考新的建造方法，用更短的畤間去達到要求。為了保證公司於內地開發的每一個項目的品質，新福港特地從香港抽調具有多年餞工作經驗的工程人員,組建了新福港施工旵質監管團隊,與工程監理單位密切配合，在工地—線進行現場監督，為項目工程品質上了雙保險。</p>'
        },
        {
          text: '<p class="title">整整一倉庫的圖紙資料，見證朗豪坊嚴謹的建造過程</p>' +
            '<p class="text">在朗豪坊建造過程中，施工安全是一個極大的挑戰。旺角地區人口密集，如果施工不慎發生材料或工具墜落，後果不堪設想。所以我們毎一個步驟都十分謹慎，與美國捷得建築師事務所緊密配合，不斷進行設計修正，確保工程有效率而且安全。設計師為朗豪坊設計了一個“山洞”，用石頭砌成很多不規則的墻身組合十分重要，新福港必須要硏究岀可行的方法，\n' +
            '確保能符合政府的結構要求。新福港在墻身底部増加做了一層防水處理，以便將設計師的圖紙細化成不同的工作部分，確保能做到預期的設計效果。此外，用來裝設石材的支架，新福港花了很多功夫去計算，以確保墻面的穩固。事後在整理圖紙資料時發現，朗豪坊的設計圖紙堆滿了整整一個大倉庫，完全可以做一個專題固書館。</p>'
        },
        {
          text: '<p class="text">新福港對每一工程都力求完美，凡事心身體力行，以超過65年的精工經驗和專業的建築品質，打造每—棟建築。新福港深信，建築是—種文化的表現，而新福港的岀品，則是新福港文化的呈獻。新福港以專業的建築技術，讓建築物的內在文化和意蘊得以流露，把美感、人文關懷融入建築當中,讓身處建築的每一個人,都能感受新福港的用心。而整個工程每部分的每個細節體驗上，新福港都把它們交給最專業的人來做，從而在每細節上都能做到最好，這樣才能打造出整體完美的建築。材料選取、規劃設計、園林打造、物業管理等各項工作,都與人居息息相關，新福港禮聘國際知名、專業的公司服務，精工細作，專業薈萃，只為打造完美的建築，完美的人居。</p>'
        },
        {
          text: '<p class="title">“1+1雙保險合作模式”\n<br/>' +
            '國際化理念與中國居住文化的結合</p>' +
            '<p class="text">要做好一個項目，就得選擇好的合作夥伴，新福港地產基本上只考慮與行業排名前十位的公司合作。在總體規劃、交通、園林消防、設備、結構、裝修等設計方面，均采用“1+1”的合作模式，選擇1家國際公司做顧問，同時選擇1家國內公司做執行。以保證我們的項目既具備國際化設計視野，又能符合國內消費需求。正如同家長給孩子選擇名師一樣，新福港地產願意花更多的項目費用，就是爲了能讓我們的項目贏在起點，不輸在未來。</p>'
        },
        {
          text: '<p class="text">新福港以香港商業物業的管理標準，秉承在朗豪坊、花旗銀行廣場、鷹君中心等高檔物業管理中積累下來的尊貴服務經驗，帶來更好的體驗和享用，讓業主的生活從此與眾不同。\n' +
            '新福港不斷鑽研與業主生活相關的一些服務細節，竭力幫助業主去提升生活。從業主生活的方方面面去考慮，我們越用心，業主就越省心，我們多做好一個細飾，就為業主多創造一份生活價值。\n' +
            '在新福港看來。服務不僅是物業管理職責所系，更應該註入—份互助與關懷的人文情感。我們期望，通過我們的用心工作，家能成為正您一天辛勤工作之後的安樂窩，更是您與愛侶、至親共度甜蜜時光的美好天地。</p>'
        },
        {
          text: '<p class="title">交樓，交給客廠全部管圖,\n<br/>' +
            '才是為客戶思考周全</p>' +
            '<p class="text">許多開發商的做法是：將房子鑰匙漂漂亮亮交到客戶手中，就算是完事了。但新福港在這一方面為客戶想得更多，想得更細。\n' +
            '房子以後的維護保養，很多時候都需要管線圖，客戶需要知道房子管的佈局。新福港註意到了這個細節，在交樓那一刻，就將房子的全部管線圖一並交給客戶，如此貼心，沒有細微的洞察和周全的思考，是很難做到的。</p>'
        },
        {
          text: '<p class="title"></p>' +
            '<p class="text"></p>' +
            '<p class="title title2"></>' +
            '<p class="text"></p>'
        }
      ]
    },
    idea: {
      title: '人才理念',
      text: '重視人才是新福港的企業哲學，公司尊重每一個員工的辛勤付出，珍惜與每一個員工在工作中建立起來的寶貴情誼。<br/>\n' +
        '公司鼓勵員工將個人追求融入公司長遠發展之中，創造公平的工作平臺和積極的工作氛圍，使員工在企業發展過程中實<br/>\n' +
        '現個人理想，創造職業價值。<br/>\n' +
        '我們認為成功並不在於財富，而是建基於提升生活與達成夢想的喜悅。新福港要凝聚一批有生活夢想和激情的人，恪守本份，竭力幫助我們的客戶去提升生活。<br/>\n' +
        '我們深願能為每一位員工帶來奇妙的人生旅程，成就事業並獲得心靈滿足。'
    },
    statement: {
      breadcrumb: '招聘聲明',
      title: '聲明函',
      text1: '各位應聘者： <br/>\n' +
        '　　為防止不法分子假冒我公司名義在網上招聘的情況，本公司就此事項聲明如下：<br/>\n' +
        '　　一、本公司及各項目公司從未以任何形式、任何途徑向應聘者發出赴外地培訓或收取任何費用等信息；<br/>\n' +
        '　　二、本公司及各項目公司的招聘信息以公司網站www.sfkp.cn和前程無憂網站www.51job.com對外公佈的信息為準；<br/>\n' +
        '　　三、本公司對外公佈的招聘聯系人及聯系方式為：',
      text2: '　　聯系人：孫小姐； <br/>\n' +
        '　　公司總機電話：020-38391008；傳真：020-3201 2390；<br/>\n' +
        '　　E-mail: gz@sfk.cn；　　郵編：510610；<br/>\n' +
        '　　地址：廣州市天河區林和東路285號天安人壽中心7樓',
      text3: '　　敬請大家提高警惕，謹防上當受騙，以免造成各種損失。本公司將收集證據並保留通過法律途徑維護我公司合法權益的權利。同時保留對不法分子追究法律責任的權力。 <br/>\n' +
        '　　特此聲明！',
      text4: '新福港地產有限公司 <br/>\n' +
        '                                                               二O一八年七月二十日'
    },
    position: {
      breadcrumb: '崗位招聘',
      title: '廣州新福港地產置業有限公司作為新福港集團房地產業務在內地的主要運作平臺,為適應公司業務不斷發展的需要,現高薪誠聘各方精英加盟。',
      email: '投遞簡歷',
      des: '職位描述',
      pay: '薪資範圍',
      person: '招聘人數',
      yuan: '元',
      ren: '人',
      name: '姓名',
      mobile: '電話',
      levelWord: '留言',
      position: '投遞崗位',
      path: '上傳附件',
      file: '選擇文件',
      uploadTip: '只能上傳doc/docx文件，且不超過5mb',
      select: '請選擇',
      submit: '提交',
      reset: '重置',
      sending: '郵件發送中',
      sengdEmail: '接收郵箱',
      duty: '崗位職責'
    },
    legal: {
      breadcrumb: '法律聲明',
      title: '法律聲明',
      text: '　　未經新福港地產有限公司書面許可，本網站瀏覽者不得以任何方式分發、改動、傳播或使用本網站的內容作公開或商業用途。本網站一切內容及資料，只可下載作非商業用途或供個人使用。在任何情況下，如未經新福港地產有限公司書面許可，任何人不得使用本網站所涉及的任何知識產權。<br/>\n' +
        '<br/>\n' +
        ' 免責聲明：<br/>\n' +
        '<br/>\n' +
        '　　新福港地產有限公司對網站所包含之信息的準確性不作任何保證，您在使用和瀏覽網站時須完全自負風險。對於因網站上不準確或不正確的任何信息給您造成的損失或損害，新福港地產有限公司不承擔任何賠償責任。本網站所有內容僅為示意說明，有關住宅樓盤的一切信息均以政府有關部門最後批復及正式簽署的《商品房買賣合同》記載為準。<br/>\n' +
        '<br/>\n' +
        '　　在任何情況下，新福港地產有限公司均不對因使用本網站或任何其它被超級鏈接的網站而導致的任何直接的、間接的、特別的或其它後果性的損害承擔賠償責任，包括但不限於任何利潤損失、業務中斷、程序丟失或您的信息處理系統或其它設備上的數據丟失等，即使我們已被明確告知存在發生這些損害的可能性。網站所含的信息可隨時更改或修訂，而無須也無義務發佈事先通知。<br/>\n' +
        '<br/>\n' +
        '　　新福港地產有限公司及本網站所陳述的公司及個人，無須為本網站所載的任何錯漏負責，並保留權利做出修改而無須事先通知。上述人士無須對本網站或其所載資料的使用或提述負責，亦無須就任何由本網站或其所載資料引起的或與之有關的損失承擔責任。'
    }
  },
  contact: {
    nav: {
      title: '聯系我們',
      item1: '聯系我們'
    },
    info: {
      breadcrumb: '聯系我們',
      title: '新福港地產有限公司 ',
      text: '地址：廣州市天河區林和東路285號天安人壽中心7樓<br/>\n' +
        '郵編：510610<br/>\n' +
        '電話：（86-020）3839 1008<br/>\n' +
        '傳真：（86-020）3839 1905<br/>\n' +
        '電郵：gz@sfk.cn'
    }
  },
  quality: {
    nav: {
      title: 'SFK品質',
      item1: '設計',
      item2: '規劃',
      item3: '施工',
      item4: '質檢',
      item5: '服務'
    },
    design: {
      breadcrumb: '設計',
      text: '　　新福港在各主要房地產及物業開發項目的選址上均經過細意考量，務求達到生活既被蒼翠的大自然環抱，又具備二十一世紀都市的先進設備及咫尺之隔的便利。<br/>\n' +
        '<br/>\n' +
        '　　在進行項目分析的時候，我們會詳細了解和評估項目所處的位置、自然環境、人文景觀消費需求，以及城市發展對項目的需求，註重人文素養在建築中的體現。<br/>\n' +
        '<br/>\n' +
        '　　我們嘗試站在客戶的角度來規劃項目，考慮到他們對環境、對空間、對生活、對社交等各個方面的期望，創造更為理想、和諧的美滿生活。'
    },
    buy: {
      breadcrumb: '規劃',
      text: '　　在新福港，規劃是對生活的全面思考，我們不光是創造建築，更多的是在創造生活。<br/>\n' +
        '<br/>\n' +
        '　　生活應該有快樂的一面，生活應該有甜蜜的一面，生活還有溫馨的一面。建築規劃，呈現幸福生活方方面面。'
    },
    work: {
      breadcrumb: '施工',
      text: '　　新福港在香港就以工程質量著稱，我們認為，再宏偉的設計構想，如果不賦予一個嚴謹到苛刻的建造過程，也沒有成為現實的可能。<br/>\n' +
        '<br/>\n' +
        '　　在建築過程中，我們與設計師緊密聯系，每一個細節做了很詳細的施工圖，確保每一個細部都是準確無誤。每一道工序都有嚴謹的規劃，確保項目施工按計劃有條不紊進行。如果需要趕工，我們也絕不會犧牲質量，而是思考新的建造方法，用更短的時間去達到要求。<br/>\n' +
        '<br/>\n' +
        '　　為保證公司於內地開發項目的建築品質，新福港特地從香港抽調具有多年一線工作經驗的工程人員，組建了新福港施工品質監管團隊，在工地一線進行現場監督，與工程監理單位密切配合，為項目工程品質上了雙保險。 '
    },
    test: {
      breadcrumb: '質檢',
      text: '　　在新福港，質量檢測貫穿項目建設的始終，是新福港永久工程標準中重要的一環。<br/>\n' +
        '<br/>\n' +
        '　　對於每一樣建材，我們要求供應商提供權威檢測機構出具的質量合格證明或樣本檢測報告，並對重要的建築材料進行抽樣檢測，確保建材符合質量標準。<br/>\n' +
        '<br/>\n' +
        '　　從我們的專業經驗來說，符合質量標準不一定等於安全可靠，所以我們還會在施工中進行反復測試，對項目的結構有所掌握。'
    },
    serve: {
      breadcrumb: '服務',
      text: '　　新福港地產註重服務品質帶給消費者的體驗，處處悉心，以港式尊貴服務標準，帶給客戶更多感動。<br/>\n' +
        '<br/>\n' +
        '　　在銷售接待服務中，我們站在客戶角度換位思考，提前做好客戶接待預案，以保證客戶在咨詢、選購、簽約、收樓等過程中都能舒心順利。<br/>\n' +
        '<br/>\n' +
        '　　我們特意聘請香港鷹君物業作為新福港地產的物業服務顧問，確保管理標準化和服務規範化，按五星級酒店服務標準製定項目物業服務方案。'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/tw.js